import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/drone/src/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/drone/src/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/drone/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/drone/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/drone/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "core-js/modules/es.string.trim-end.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { dropUndefinedKeys, logger } from '@sentry/utils';
import { DEBUG_BUILD } from '../debug-build.js';
import { getCurrentHub } from '../hub.js';
import { getMetricSummaryJsonForSpan } from '../metrics/metric-summary.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE } from '../semanticAttributes.js';
import { spanTimeInputToSeconds, spanToJSON, spanToTraceContext } from '../utils/spanUtils.js';
import { getDynamicSamplingContextFromSpan } from './dynamicSamplingContext.js';
import { Span, SpanRecorder } from './span.js';
import { getCapturedScopesOnSpan } from './trace.js';

/** JSDoc */
var Transaction = /*#__PURE__*/function (_Span) {
  _inherits(Transaction, _Span);
  var _super = _createSuper(Transaction);
  /**
   * The reference to the current hub.
   */
  // eslint-disable-next-line deprecation/deprecation

  // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  // eslint-disable-next-line deprecation/deprecation
  function Transaction(transactionContext, hub) {
    var _this;
    _classCallCheck(this, Transaction);
    _this = _super.call(this, transactionContext);
    _this._contexts = {};

    // eslint-disable-next-line deprecation/deprecation
    _this._hub = hub || getCurrentHub();
    _this._name = transactionContext.name || '';
    _this._metadata = _objectSpread({}, transactionContext.metadata);
    _this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    // TODO (v8): Replace this with another way to set the root span
    // eslint-disable-next-line deprecation/deprecation
    _this.transaction = _assertThisInitialized(_this);

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    var incomingDynamicSamplingContext = _this._metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      _this._frozenDynamicSamplingContext = _objectSpread({}, incomingDynamicSamplingContext);
    }
    return _this;
  }

  // This sadly conflicts with the getter/setter ordering :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  _createClass(Transaction, [{
    key: "name",
    get: function get() {
      return this._name;
    }

    /**
     * Setter for `name` property, which also sets `source` as custom.
     * @deprecated Use `updateName()` and `setMetadata()` instead.
     */,
    set: function set(newName) {
      // eslint-disable-next-line deprecation/deprecation
      this.setName(newName);
    }

    /**
     * Get the metadata for this transaction.
     * @deprecated Use `spanGetMetadata(transaction)` instead.
     */
  }, {
    key: "metadata",
    get: function get() {
      // We merge attributes in for backwards compatibility
      return _objectSpread(_objectSpread(_objectSpread({
        // Defaults
        // eslint-disable-next-line deprecation/deprecation
        source: 'custom',
        spanMetadata: {}
      }, this._metadata), this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
        source: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
      }), this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
        sampleRate: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
      });
    }

    /**
     * Update the metadata for this transaction.
     * @deprecated Use `spanGetMetadata(transaction)` instead.
     */,
    set: function set(metadata) {
      this._metadata = metadata;
    }

    /* eslint-enable @typescript-eslint/member-ordering */

    /**
     * Setter for `name` property, which also sets `source` on the metadata.
     *
     * @deprecated Use `.updateName()` and `.setAttribute()` instead.
     */
  }, {
    key: "setName",
    value: function setName(name) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'custom';
      this._name = name;
      this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source);
    }

    /** @inheritdoc */
  }, {
    key: "updateName",
    value: function updateName(name) {
      this._name = name;
      return this;
    }

    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
  }, {
    key: "initSpanRecorder",
    value: function initSpanRecorder() {
      var maxlen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      // eslint-disable-next-line deprecation/deprecation
      if (!this.spanRecorder) {
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new SpanRecorder(maxlen);
      }
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.add(this);
    }

    /**
     * Set the context of a transaction event.
     * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
     */
  }, {
    key: "setContext",
    value: function setContext(key, context) {
      if (context === null) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
      } else {
        this._contexts[key] = context;
      }
    }

    /**
     * @inheritDoc
     *
     * @deprecated Use top-level `setMeasurement()` instead.
     */
  }, {
    key: "setMeasurement",
    value: function setMeasurement(name, value) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this._measurements[name] = {
        value: value,
        unit: unit
      };
    }

    /**
     * Store metadata on this transaction.
     * @deprecated Use attributes or store data on the scope instead.
     */
  }, {
    key: "setMetadata",
    value: function setMetadata(newMetadata) {
      this._metadata = _objectSpread(_objectSpread({}, this._metadata), newMetadata);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "end",
    value: function end(endTimestamp) {
      var timestampInS = spanTimeInputToSeconds(endTimestamp);
      var transaction = this._finishTransaction(timestampInS);
      if (!transaction) {
        return undefined;
      }
      // eslint-disable-next-line deprecation/deprecation
      return this._hub.captureEvent(transaction);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "toContext",
    value: function toContext() {
      // eslint-disable-next-line deprecation/deprecation
      var spanContext = _get(_getPrototypeOf(Transaction.prototype), "toContext", this).call(this);
      return dropUndefinedKeys(_objectSpread(_objectSpread({}, spanContext), {}, {
        name: this._name,
        trimEnd: this._trimEnd
      }));
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "updateWithContext",
    value: function updateWithContext(transactionContext) {
      // eslint-disable-next-line deprecation/deprecation
      _get(_getPrototypeOf(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);
      this._name = transactionContext.name || '';
      this._trimEnd = transactionContext.trimEnd;
      return this;
    }

    /**
     * @inheritdoc
     *
     * @experimental
     *
     * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
     */
  }, {
    key: "getDynamicSamplingContext",
    value: function getDynamicSamplingContext() {
      return getDynamicSamplingContextFromSpan(this);
    }

    /**
     * Override the current hub with a new one.
     * Used if you want another hub to finish the transaction.
     *
     * @internal
     */
    // eslint-disable-next-line deprecation/deprecation
  }, {
    key: "setHub",
    value: function setHub(hub) {
      this._hub = hub;
    }

    /**
     * Get the profile id of the transaction.
     */
  }, {
    key: "getProfileId",
    value: function getProfileId() {
      if (this._contexts !== undefined && this._contexts['profile'] !== undefined) {
        return this._contexts['profile'].profile_id;
      }
      return undefined;
    }

    /**
     * Finish the transaction & prepare the event to send to Sentry.
     */
  }, {
    key: "_finishTransaction",
    value: function _finishTransaction(endTimestamp) {
      var _this2 = this;
      // This transaction is already finished, so we should not flush it again.
      if (this._endTime !== undefined) {
        return undefined;
      }
      if (!this._name) {
        DEBUG_BUILD && logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
        this._name = '<unlabeled transaction>';
      }

      // just sets the end timestamp
      _get(_getPrototypeOf(Transaction.prototype), "end", this).call(this, endTimestamp);

      // eslint-disable-next-line deprecation/deprecation
      var client = this._hub.getClient();
      if (client && client.emit) {
        client.emit('finishTransaction', this);
      }
      if (this._sampled !== true) {
        // At this point if `sampled !== true` we want to discard the transaction.
        DEBUG_BUILD && logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
        if (client) {
          client.recordDroppedEvent('sample_rate', 'transaction');
        }
        return undefined;
      }

      // eslint-disable-next-line deprecation/deprecation
      var finishedSpans = this.spanRecorder ?
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.spans.filter(function (span) {
        return span !== _this2 && spanToJSON(span).timestamp;
      }) : [];
      if (this._trimEnd && finishedSpans.length > 0) {
        var endTimes = finishedSpans.map(function (span) {
          return spanToJSON(span).timestamp;
        }).filter(Boolean);
        this._endTime = endTimes.reduce(function (prev, current) {
          return prev > current ? prev : current;
        });
      }
      var _getCapturedScopesOnS = getCapturedScopesOnSpan(this),
        capturedSpanScope = _getCapturedScopesOnS.scope,
        capturedSpanIsolationScope = _getCapturedScopesOnS.isolationScope;

      // eslint-disable-next-line deprecation/deprecation
      var metadata = this.metadata;
      // eslint-disable-next-line deprecation/deprecation
      var source = metadata.source;
      var transaction = _objectSpread({
        contexts: _objectSpread(_objectSpread({}, this._contexts), {}, {
          // We don't want to override trace context
          trace: spanToTraceContext(this)
        }),
        // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
        spans: finishedSpans,
        start_timestamp: this._startTime,
        // eslint-disable-next-line deprecation/deprecation
        tags: this.tags,
        timestamp: this._endTime,
        transaction: this._name,
        type: 'transaction',
        sdkProcessingMetadata: _objectSpread(_objectSpread({}, metadata), {}, {
          capturedSpanScope: capturedSpanScope,
          capturedSpanIsolationScope: capturedSpanIsolationScope
        }, dropUndefinedKeys({
          dynamicSamplingContext: getDynamicSamplingContextFromSpan(this)
        })),
        _metrics_summary: getMetricSummaryJsonForSpan(this)
      }, source && {
        transaction_info: {
          source: source
        }
      });
      var hasMeasurements = Object.keys(this._measurements).length > 0;
      if (hasMeasurements) {
        DEBUG_BUILD && logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
        transaction.measurements = this._measurements;
      }

      // eslint-disable-next-line deprecation/deprecation
      DEBUG_BUILD && logger.log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this._name, "."));
      return transaction;
    }
  }]);
  return Transaction;
}(Span);
export { Transaction };